// import React, { useEffect, useState } from "react";
// import { Button } from "antd";
// import SetAlarm from "./SetAlarm";
// import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
// import { post } from "../../../../services/services";
// import { ApiURL } from "../../../../services/apiConstants";

// function AlarmView({ id, onSuccess }) {
//   const [loader, set_loader] = useState(false);
//   const [errors, set_errors] = useState();
//   const [main_exhaust_temp, set_main_exhaust_temp] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [scavenge_box_temp, set_scavenge_box_temp] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [jacket_water_temp, set_jacket_water_temp] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [piston_cooling_oil_out_temp, set_piston_cooling_oil_out_temp] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [fuel_rack, set_fuel_rack] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [fuel_oil_inlet, set_fuel_oil_inlet] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [scavenge_air_inlet, set_scavenge_air_inlet] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [lube_oil_inlet, set_lube_oil_inlet] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [egb_inlet, set_egb_inlet] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [egb_outlet, set_egb_outlet] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [exh_in, set_exh_in] = useState({ max: null, orange: null, red: null });
//   const [exh_out, set_exh_out] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [air_in, set_air_in] = useState({ max: null, orange: null, red: null });
//   const [air_out, set_air_out] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [fuel_oil_inlet_to_engine, set_fuel_oil_inlet_to_engine] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });
//   const [auxi_exhaust_temp, set_auxi_exhaust_temp] = useState({
//     max: null,
//     orange: null,
//     red: null,
//   });

//   const ADD_ALARM_API = () => {
//     set_loader(true);
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("ship_id", Number(id));
//       FORM_DATA.append("main_exhaust_temp", JSON.stringify(main_exhaust_temp));
//       FORM_DATA.append("scavenge_box_temp", JSON.stringify(scavenge_box_temp));
//       FORM_DATA.append("jacket_water_temp", JSON.stringify(jacket_water_temp));
//       FORM_DATA.append("piston_cooling_oil_out_temp", JSON.stringify(piston_cooling_oil_out_temp));
//       FORM_DATA.append("fuel_rack", JSON.stringify(fuel_rack));
//       FORM_DATA.append("fuel_oil_inlet", JSON.stringify(fuel_oil_inlet));
//       FORM_DATA.append("scavenge_air_inlet", JSON.stringify(scavenge_air_inlet));
//       FORM_DATA.append("lube_oil_inlet", JSON.stringify(lube_oil_inlet));
//       FORM_DATA.append("egb_inlet", JSON.stringify(egb_inlet));
//       FORM_DATA.append("egb_outlet", JSON.stringify(egb_outlet));
//       FORM_DATA.append("exh_in", JSON.stringify(exh_in));
//       FORM_DATA.append("exh_out", JSON.stringify(exh_out));
//       FORM_DATA.append("air_in", JSON.stringify(air_in));
//       FORM_DATA.append("air_out", JSON.stringify(air_out));
//       FORM_DATA.append("fuel_oil_inlet_to_engine", JSON.stringify(fuel_oil_inlet_to_engine));
//       FORM_DATA.append("auxi_exhaust_temp", JSON.stringify(auxi_exhaust_temp));
//       post(ApiURL.add_alarm_conditions_com, FORM_DATA).then((res) => {
//         if (res?.status == true) {
//           SuccessToast("Congratulation!!", res?.message);
//           set_loader(false);
//           if (onSuccess) onSuccess();
//         } else {
//           const rawErrors = res?.errors || res?.response?.data?.errors || {};
//           const transformedErrors = Array.isArray(rawErrors)
//             ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
//             : rawErrors;
//           set_errors(transformedErrors);
//           set_loader(false);
//         }
//       });
//     } catch (error) {
//       set_loader(false);
//       ErrorToast("Error Occurred", "There was an error during registration.");
//     }
//   };

//   const VIEW_ALARM_API = () => {
//     try {
//       const FORM_DATA = new FormData();
//       FORM_DATA.append("ship_id", Number(id));
//       post(ApiURL.view_alarm_conditions_com, FORM_DATA).then((res) => {
//         const alarm_condition_datas = res?.alarm_condition_data || {};
//         if (res?.status == true && alarm_condition_datas) {
//           set_main_exhaust_temp(JSON.parse(alarm_condition_datas.main_exhaust_temp));
//           set_scavenge_box_temp(JSON.parse(alarm_condition_datas.scavenge_box_temp));
//           set_jacket_water_temp(JSON.parse(alarm_condition_datas.jacket_water_temp));
//           set_piston_cooling_oil_out_temp(
//             JSON.parse(alarm_condition_datas.piston_cooling_oil_out_temp)
//           );
//           set_fuel_rack(JSON.parse(alarm_condition_datas.fuel_rack));
//           set_fuel_oil_inlet(JSON.parse(alarm_condition_datas.fuel_oil_inlet));
//           set_scavenge_air_inlet(JSON.parse(alarm_condition_datas.scavenge_air_inlet));
//           set_lube_oil_inlet(JSON.parse(alarm_condition_datas.lube_oil_inlet));
//           set_egb_inlet(JSON.parse(alarm_condition_datas.egb_inlet));
//           set_egb_outlet(JSON.parse(alarm_condition_datas.egb_outlet));
//           set_exh_in(JSON.parse(alarm_condition_datas.exh_in));
//           set_exh_out(JSON.parse(alarm_condition_datas.exh_out));
//           set_air_in(JSON.parse(alarm_condition_datas.air_in));
//           set_air_out(JSON.parse(alarm_condition_datas.air_out));
//           set_fuel_oil_inlet_to_engine(JSON.parse(alarm_condition_datas.fuel_oil_inlet_to_engine));
//           set_auxi_exhaust_temp(JSON.parse(alarm_condition_datas.auxi_exhaust_temp));
//         } else {
//           const rawErrors = res?.errors || res?.response?.data?.errors || {};
//           const transformedErrors = Array.isArray(rawErrors)
//             ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
//             : rawErrors;
//           set_errors(transformedErrors);
//         }
//       });
//     } finally {
//     }
//   };

//   useEffect(() => {
//     VIEW_ALARM_API();
//   }, []);

//   return (
//     <>
//       <div className="white-container">
//         <div style={{ margin: "6px 0px" }}>
//           <h4>
//             <strong>1. Maximum :</strong>{" "}
//             <span style={{ fontWeight: "lighter" }}>Max range of data.</span>
//           </h4>
//           <h4>
//             <strong>2. Warning (Orange) :</strong>{" "}
//             <span style={{ fontWeight: "lighter" }}>
//               User need to check for the cause and resolve.
//             </span>
//           </h4>
//           <h4>
//             <strong>3. Critical (Red) :</strong>{" "}
//             <span style={{ fontWeight: "lighter" }}>User needs to take immediate action.</span>
//           </h4>
//         </div>

//         <div style={{ margin: "6px 0px" }}>
//           <h3>Main Engine Details </h3>
//         </div>
//         <div className="row">
//           <div className="col-6">
//             <div className="input-box">
//               <label>Main Exhaust Temp</label>
//               <SetAlarm get_json={main_exhaust_temp} set_json={set_main_exhaust_temp} />
//               {errors?.main_exhaust_temp && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.main_exhaust_temp}</span>
//                 </>
//               )}
//             </div>
//           </div>
//           <div className="col-6">
//             <div className="input-box">
//               <label>Scavenge Box Temp</label>
//               <SetAlarm get_json={scavenge_box_temp} set_json={set_scavenge_box_temp} />
//               {errors?.scavenge_box_temp && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.scavenge_box_temp}</span>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-6">
//             <div className="input-box">
//               <label>Jacket Water Temp</label>
//               <SetAlarm get_json={jacket_water_temp} set_json={set_jacket_water_temp} />
//               {errors?.jacket_water_temp && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.jacket_water_temp}</span>
//                 </>
//               )}
//             </div>
//           </div>
//           <div className="col-6">
//             <div className="input-box">
//               <label>Piston Cooling oil out Temp </label>
//               <SetAlarm
//                 get_json={piston_cooling_oil_out_temp}
//                 set_json={set_piston_cooling_oil_out_temp}
//               />
//               {errors?.piston_cooling_oil_out_temp && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.piston_cooling_oil_out_temp}</span>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-6">
//             <div className="input-box">
//               <label>Fuel Rack</label>
//               <SetAlarm get_json={fuel_rack} set_json={set_fuel_rack} />
//               {errors?.fuel_rack && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.fuel_rack}</span>
//                 </>
//               )}
//             </div>
//           </div>
//           <div className="col-6">
//             <div className="input-box">
//               <label>Fuel oil Inlet Temp</label>
//               <SetAlarm get_json={fuel_oil_inlet} set_json={set_fuel_oil_inlet} />
//               {errors?.fuel_oil_inlet && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.fuel_oil_inlet}</span>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-6">
//             <div className="input-box">
//               <label>Scavenge Air Inlet Temp</label>
//               <SetAlarm get_json={scavenge_air_inlet} set_json={set_scavenge_air_inlet} />
//               {errors?.scavenge_air_inlet && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.scavenge_air_inlet}</span>
//                 </>
//               )}
//             </div>
//           </div>
//           <div className="col-6">
//             <div className="input-box">
//               <label>Lube Oil inlet Temp</label>
//               <SetAlarm get_json={lube_oil_inlet} set_json={set_lube_oil_inlet} />
//               {errors?.lube_oil_inlet && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.lube_oil_inlet}</span>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-6">
//             <div className="input-box">
//               <label>EGB Inlet Temp</label>
//               <SetAlarm get_json={egb_inlet} set_json={set_egb_inlet} />
//               {errors?.egb_inlet && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.egb_inlet}</span>
//                 </>
//               )}
//             </div>
//           </div>
//           <div className="col-6">
//             <div className="input-box">
//               <label>EGB outlet Temp</label>
//               <SetAlarm get_json={egb_outlet} set_json={set_egb_outlet} />
//               {errors?.egb_outlet && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.egb_outlet}</span>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-6">
//             <div className="input-box">
//               <label>T/C Exhaust Inlet Temp</label>
//               <SetAlarm get_json={exh_in} set_json={set_exh_in} />
//               {errors?.exh_in && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.exh_in}</span>
//                 </>
//               )}
//             </div>
//           </div>
//           <div className="col-6">
//             <div className="input-box">
//               <label>T/C Exhaust Outlet Temp</label>
//               <SetAlarm get_json={exh_out} set_json={set_exh_out} />
//               {errors?.exh_out && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.exh_out}</span>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-6">
//             <div className="input-box">
//               <label>Air Inlet Temperature Air Cooler</label>
//               <SetAlarm get_json={air_in} set_json={set_air_in} />
//               {errors?.air_in && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.air_in}</span>
//                 </>
//               )}
//             </div>
//           </div>
//           <div className="col-6">
//             <div className="input-box">
//               <label>Air Outlet Temperature Air Cooler</label>
//               <SetAlarm get_json={air_out} set_json={set_air_out} />
//               {errors?.air_out && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.air_out}</span>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className="row">
//           <div className="col-6">
//             <div className="input-box">
//               <label>Fuel oil Inlet to engine Temp</label>
//               <SetAlarm
//                 get_json={fuel_oil_inlet_to_engine}
//                 set_json={set_fuel_oil_inlet_to_engine}
//               />
//               {errors?.fuel_oil_inlet_to_engine && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.fuel_oil_inlet_to_engine}</span>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>

//         <div style={{ margin: "6px 0px" }}>
//           <h3>Auxiliary Engine Details </h3>
//         </div>

//         <div className="row">
//           <div className="col-6">
//             <div className="input-box">
//               <label>Auxiliary exhaust Temp</label>
//               <SetAlarm get_json={auxi_exhaust_temp} set_json={set_auxi_exhaust_temp} />
//               {errors?.auxi_exhaust_temp && (
//                 <>
//                   <span style={{ color: "red" }}>{errors?.auxi_exhaust_temp}</span>
//                 </>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="col-3">
//           <Button type="primary" onClick={ADD_ALARM_API} loading={loader}>
//             Save
//           </Button>
//         </div>
//       </div>
//     </>
//   );
// }

// export default AlarmView;


import React, { useEffect, useState } from "react";
import { Button } from "antd";
import SetAlarm from "./SetAlarm";
import { ErrorToast, SuccessToast } from "../../../../widgets/AppToast";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";

function AlarmView({ id, onSuccess }) {
  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState();
  const [main_exhaust_temp, set_main_exhaust_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [scavenge_box_temp, set_scavenge_box_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [jacket_water_temp, set_jacket_water_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [piston_cooling_oil_out_temp, set_piston_cooling_oil_out_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [fuel_rack, set_fuel_rack] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [fuel_oil_inlet, set_fuel_oil_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [scavenge_air_inlet, set_scavenge_air_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [lube_oil_inlet, set_lube_oil_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [egb_inlet, set_egb_inlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [egb_outlet, set_egb_outlet] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [exh_in, set_exh_in] = useState({ max: null, orange: null, red: null });
  const [exh_out, set_exh_out] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [air_in, set_air_in] = useState({ max: null, orange: null, red: null });
  const [air_out, set_air_out] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [fuel_oil_inlet_to_engine, set_fuel_oil_inlet_to_engine] = useState({
    max: null,
    orange: null,
    red: null,
  });
  const [auxi_exhaust_temp, set_auxi_exhaust_temp] = useState({
    max: null,
    orange: null,
    red: null,
  });

  const safeJSONParse = (data) => {
    if (!data || data === "undefined") return { max: null, orange: null, red: null };
    try {
      return JSON.parse(data);
    } catch (e) {
      return { max: null, orange: null, red: null };
    }
  };

  const ADD_ALARM_API = () => {
    set_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", Number(id));
      FORM_DATA.append("main_exhaust_temp", JSON.stringify(main_exhaust_temp));
      FORM_DATA.append("scavenge_box_temp", JSON.stringify(scavenge_box_temp));
      FORM_DATA.append("jacket_water_temp", JSON.stringify(jacket_water_temp));
      FORM_DATA.append("piston_cooling_oil_out_temp", JSON.stringify(piston_cooling_oil_out_temp));
      FORM_DATA.append("fuel_rack", JSON.stringify(fuel_rack));
      FORM_DATA.append("fuel_oil_inlet", JSON.stringify(fuel_oil_inlet));
      FORM_DATA.append("scavenge_air_inlet", JSON.stringify(scavenge_air_inlet));
      FORM_DATA.append("lube_oil_inlet", JSON.stringify(lube_oil_inlet));
      FORM_DATA.append("egb_inlet", JSON.stringify(egb_inlet));
      FORM_DATA.append("egb_outlet", JSON.stringify(egb_outlet));
      FORM_DATA.append("exh_in", JSON.stringify(exh_in));
      FORM_DATA.append("exh_out", JSON.stringify(exh_out));
      FORM_DATA.append("air_in", JSON.stringify(air_in));
      FORM_DATA.append("air_out", JSON.stringify(air_out));
      FORM_DATA.append("fuel_oil_inlet_to_engine", JSON.stringify(fuel_oil_inlet_to_engine));
      FORM_DATA.append("auxi_exhaust_temp", JSON.stringify(auxi_exhaust_temp));
      post(ApiURL.add_alarm_conditions_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          SuccessToast("Congratulation!!", res?.message);
          set_loader(false);
          if (onSuccess) onSuccess();
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
          set_loader(false);
        }
      });
    } catch (error) {
      set_loader(false);
      ErrorToast("Error Occurred", "There was an error during registration.");
    }
  };

  const VIEW_ALARM_API = () => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", Number(id));
      post(ApiURL.view_alarm_conditions_com, FORM_DATA).then((res) => {
        const alarm_condition_datas = res?.alarm_condition_data || {};
        if (res?.status == true && alarm_condition_datas) {
          set_main_exhaust_temp(safeJSONParse(alarm_condition_datas.main_exhaust_temp));
          set_scavenge_box_temp(safeJSONParse(alarm_condition_datas.scavenge_box_temp));
          set_jacket_water_temp(safeJSONParse(alarm_condition_datas.jacket_water_temp));
          set_piston_cooling_oil_out_temp(
            safeJSONParse(alarm_condition_datas.piston_cooling_oil_out_temp)
          );
          set_fuel_rack(safeJSONParse(alarm_condition_datas.fuel_rack));
          set_fuel_oil_inlet(safeJSONParse(alarm_condition_datas.fuel_oil_inlet));
          set_scavenge_air_inlet(safeJSONParse(alarm_condition_datas.scavenge_air_inlet));
          set_lube_oil_inlet(safeJSONParse(alarm_condition_datas.lube_oil_inlet));
          set_egb_inlet(safeJSONParse(alarm_condition_datas.egb_inlet));
          set_egb_outlet(safeJSONParse(alarm_condition_datas.egb_outlet));
          set_exh_in(safeJSONParse(alarm_condition_datas.exh_in));
          set_exh_out(safeJSONParse(alarm_condition_datas.exh_out));
          set_air_in(safeJSONParse(alarm_condition_datas.air_in));
          set_air_out(safeJSONParse(alarm_condition_datas.air_out));
          set_fuel_oil_inlet_to_engine(safeJSONParse(alarm_condition_datas.fuel_oil_inlet_to_engine));
          set_auxi_exhaust_temp(safeJSONParse(alarm_condition_datas.auxi_exhaust_temp));
        } else {
          const rawErrors = res?.errors || res?.response?.data?.errors || {};
          const transformedErrors = Array.isArray(rawErrors)
            ? rawErrors.reduce((acc, curr) => ({ ...acc, ...curr }), {})
            : rawErrors;
          set_errors(transformedErrors);
        }
      });
    } finally {
    }
  };

  useEffect(() => {
    VIEW_ALARM_API();
  }, []);

  return (
    <>
      <div className="white-container">
        <div style={{ margin: "6px 0px" }}>
          <h4>
            <strong>1. Maximum :</strong>{" "}
            <span style={{ fontWeight: "lighter" }}>Max range of data.</span>
          </h4>
          <h4>
            <strong>2. Warning (Orange) :</strong>{" "}
            <span style={{ fontWeight: "lighter" }}>
              User need to check for the cause and resolve.
            </span>
          </h4>
          <h4>
            <strong>3. Critical (Red) :</strong>{" "}
            <span style={{ fontWeight: "lighter" }}>User needs to take immediate action.</span>
          </h4>
        </div>

        <div style={{ margin: "6px 0px" }}>
          <h3>Main Engine Details </h3>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Main Exhaust Temp</label>
              <SetAlarm get_json={main_exhaust_temp} set_json={set_main_exhaust_temp} />
              {errors?.main_exhaust_temp && (
                <>
                  <span style={{ color: "red" }}>{errors?.main_exhaust_temp}</span>
                </>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Scavenge Box Temp</label>
              <SetAlarm get_json={scavenge_box_temp} set_json={set_scavenge_box_temp} />
              {errors?.scavenge_box_temp && (
                <>
                  <span style={{ color: "red" }}>{errors?.scavenge_box_temp}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Jacket Water Temp</label>
              <SetAlarm get_json={jacket_water_temp} set_json={set_jacket_water_temp} />
              {errors?.jacket_water_temp && (
                <>
                  <span style={{ color: "red" }}>{errors?.jacket_water_temp}</span>
                </>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Piston Cooling oil out Temp </label>
              <SetAlarm
                get_json={piston_cooling_oil_out_temp}
                set_json={set_piston_cooling_oil_out_temp}
              />
              {errors?.piston_cooling_oil_out_temp && (
                <>
                  <span style={{ color: "red" }}>{errors?.piston_cooling_oil_out_temp}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Fuel Rack</label>
              <SetAlarm get_json={fuel_rack} set_json={set_fuel_rack} />
              {errors?.fuel_rack && (
                <>
                  <span style={{ color: "red" }}>{errors?.fuel_rack}</span>
                </>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Fuel oil Inlet Temp</label>
              <SetAlarm get_json={fuel_oil_inlet} set_json={set_fuel_oil_inlet} />
              {errors?.fuel_oil_inlet && (
                <>
                  <span style={{ color: "red" }}>{errors?.fuel_oil_inlet}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Scavenge Air Inlet Temp</label>
              <SetAlarm get_json={scavenge_air_inlet} set_json={set_scavenge_air_inlet} />
              {errors?.scavenge_air_inlet && (
                <>
                  <span style={{ color: "red" }}>{errors?.scavenge_air_inlet}</span>
                </>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Lube Oil inlet Temp</label>
              <SetAlarm get_json={lube_oil_inlet} set_json={set_lube_oil_inlet} />
              {errors?.lube_oil_inlet && (
                <>
                  <span style={{ color: "red" }}>{errors?.lube_oil_inlet}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>EGB Inlet Temp</label>
              <SetAlarm get_json={egb_inlet} set_json={set_egb_inlet} />
              {errors?.egb_inlet && (
                <>
                  <span style={{ color: "red" }}>{errors?.egb_inlet}</span>
                </>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>EGB outlet Temp</label>
              <SetAlarm get_json={egb_outlet} set_json={set_egb_outlet} />
              {errors?.egb_outlet && (
                <>
                  <span style={{ color: "red" }}>{errors?.egb_outlet}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>T/C Exhaust Inlet Temp</label>
              <SetAlarm get_json={exh_in} set_json={set_exh_in} />
              {errors?.exh_in && (
                <>
                  <span style={{ color: "red" }}>{errors?.exh_in}</span>
                </>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>T/C Exhaust Outlet Temp</label>
              <SetAlarm get_json={exh_out} set_json={set_exh_out} />
              {errors?.exh_out && (
                <>
                  <span style={{ color: "red" }}>{errors?.exh_out}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Air Inlet Temperature Air Cooler</label>
              <SetAlarm get_json={air_in} set_json={set_air_in} />
              {errors?.air_in && (
                <>
                  <span style={{ color: "red" }}>{errors?.air_in}</span>
                </>
              )}
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Air Outlet Temperature Air Cooler</label>
              <SetAlarm get_json={air_out} set_json={set_air_out} />
              {errors?.air_out && (
                <>
                  <span style={{ color: "red" }}>{errors?.air_out}</span>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Fuel oil Inlet to engine Temp</label>
              <SetAlarm
                get_json={fuel_oil_inlet_to_engine}
                set_json={set_fuel_oil_inlet_to_engine}
              />
              {errors?.fuel_oil_inlet_to_engine && (
                <>
                  <span style={{ color: "red" }}>{errors?.fuel_oil_inlet_to_engine}</span>
                </>
              )}
            </div>
          </div>
        </div>

        <div style={{ margin: "6px 0px" }}>
          <h3>Auxiliary Engine Details </h3>
        </div>

        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Auxiliary exhaust Temp</label>
              <SetAlarm get_json={auxi_exhaust_temp} set_json={set_auxi_exhaust_temp} />
              {errors?.auxi_exhaust_temp && (
                <>
                  <span style={{ color: "red" }}>{errors?.auxi_exhaust_temp}</span>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="col-3">
          <Button type="primary" onClick={ADD_ALARM_API} loading={loader}>
            Save
          </Button>
        </div>
      </div>
    </>
  );
}

export default AlarmView;
